import React, { useState, useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";

const MarqueeCardItemComponent = ({
  content,
  isHalfScreen = false,
  spanClassName = "text-sm font-medium",
}) => {
  const [shouldUseMarquee, setShouldUseMarquee] = useState(false);
  const [isMarqueeRunning, setIsMarqueeRunning] = useState(true);
  const contentRef = useRef(null);

  useEffect(() => {
    // check if overflow screen
    const checkWidth = () => {
      if (contentRef.current) {
        const contentWidth = contentRef.current.offsetWidth;
        const screenWidth = isHalfScreen
          ? window.innerWidth / 2 - 60
          : window.innerWidth - 140;
        setShouldUseMarquee(contentWidth > screenWidth);
      }
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, [content]);

  if (shouldUseMarquee) {
    return (
      <Marquee
        play={isMarqueeRunning}
        onCycleComplete={() => {
          setIsMarqueeRunning(false);
          setTimeout(() => setIsMarqueeRunning(true), 3000);
        }}
      >
        <span
          className={`${spanClassName} line-clamp-1`}
        >{`${content}\u00A0\u00A0`}</span>
      </Marquee>
    );
  } else {
    return (
      <span
        className={`${spanClassName} line-clamp-1 w-max overflow-visible`}
        ref={contentRef}
      >
        {content}
      </span>
    );
  }
};

export default MarqueeCardItemComponent;
